<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="24">
        <card v-resize="onResize" v-ripple color="white" align="center" :class="['py-4']" :bg-color="$root.colors.primary" :color-lightness="null" :bg-color-lightness="$root.colors.bgColorLightness">
          <card-text :class="['text-xl']">
            <code-chunk :pre="false">{{ viewportData }}</code-chunk>
          </card-text>
        </card>
      </flex-col>
      <all-section-blocks :title="true" :tooltip="false" />
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageResize',
  mixins: [
    methods
  ],
  data () {
    return {
      viewportData: null
    }
  },
  methods: {
    onResize () {
      const viewport = this.viewport()
      this.viewportData = viewport
      this.log('resize', 'card', viewport)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/directives/resize.vue